import { Localized } from '../../localization/react'
import { Interval, Repeating, UsageLimitPeriod } from '../../typings/Product'

import { RenewalInfo } from './RenewalInfo'

interface UsageLimitPeriodInformationProps {
  usageLimitPeriod: UsageLimitPeriod
  repeating?: Repeating | null
  validityDuration?: Interval | null
}

export const UsageLimitPeriodInformation = ({
  usageLimitPeriod,
  repeating = null,
  validityDuration = null,
}: UsageLimitPeriodInformationProps) => {
  const remainingBookings = usageLimitPeriod.allowedBookings - usageLimitPeriod.usedBookings

  if (remainingBookings > 0) {
    return (
      <Localized
        id="assigned-product-usage-limit-period"
        params={{
          start: new Date(usageLimitPeriod.start),
          end: new Date(usageLimitPeriod.end),
          remainingBookings,
        }}
      />
    )
  }

  return (
    <>
      <Localized id="assigned-product-usage-limit-period-reached" />
      <RenewalInfo repeating={repeating} validityDuration={validityDuration} />
    </>
  )
}
